<mat-dialog-content>
  <lemon-dialog-header>
    {{ 'lasku.lataa-dialog.odota-pdf-luodaan' | translate | async }}
  </lemon-dialog-header>

  <div style="padding-left: 3em; padding-right: 3em">
    <div style="text-align: center">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
    <div style="margin-top: 30px; margin-bottom: 15px">
      {{ 'lasku.lataa-dialog.tiedosto-latautuu-valmistuttuaan' | translate | async }}
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <app-primary-button mat-dialog-close actionId="Peruuta (laskun lataus dialog)">{{ 'yleiset.peruuta' | translate | async }}</app-primary-button>
</mat-dialog-actions>
